import Http from '../Http';

export class ZonaService {
  static async obtenerLista(page = 0, limit = 15, filters: Record<string, string> = {}, orderBy = '', order = 'asc') {
    const params = new URLSearchParams();
    params.set('p', page.toString());
    params.set('l', limit.toString());
    
    if (Object.keys(filters).length) {
      params.set('q', JSON.stringify(filters));
    }
    if (orderBy) {
      params.set('orderBy', orderBy);
      params.set('order', order);
    }

    try {
      const res = await Http.get(`zona/filter?${params.toString()}`);
      return res.data.rows || [];
    } catch (e) {
      console.error(e);
      return [];
    }
  }

  static async obtenerPorId(id: string | number) {
    try {
      const res = await Http.get(`zona/one/${id}`);
      return res.error ? null : res.data;
    } catch (e) {
      console.error(e);
      return null;
    }
  }

  static async obtenerOpcionesForm(params: { id_estado?: any; id_zona?: any } = {}) {
    try {
      const query = new URLSearchParams();
      if (params.id_estado) query.set('id_estado', params.id_estado.toString());
      if (params.id_zona) query.set('id_zona', params.id_zona.toString());
      const res = await Http.get(`zona/form?${query.toString()}`);
      return res.error ? null : res.data;
    } catch (e) {
      console.error(e);
      return null;
    }
  }

  static async guardar(data: any) {
    try {
      const res = await Http.post(`zona/save`, data);
      return res;
    } catch (e) {
      console.error(e);
      return { error: true, errMsg: (e as any)?.message || 'Error de conexión' };
    }
  }

  static async eliminar(row: any) {
    try {
      const res = await Http.post(`zona/delete`, row);
      return !res.error;
    } catch (e) {
      console.error(e);
      return false;
    }
  }

  static async descargarReporte() {
    try {
      const res = await Http.get(`zona/excel`, true, 'arraybuffer');
      return res;
    } catch (e) {
      console.error(e);
      return null;
    }
  }
}
